import { propertyGroupQueryKeys as e } from "./propertyGroupQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertyGroupsApi as r } from "@maat/api-main";
//#region src/propertyGroups/useAssignUsersToGroupMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ groupId: e, userIds: t }) => r.assignUsers(e, t),
		onSuccess: (t, { groupId: n }) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useAssignUsersToGroupMutation };
